import * as ACTION from '../constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/effects';

export default function* () {
	yield takeLatest(ACTION.UPDATE_PROPERTY.REQUEST, saga.updateProperty);
	yield takeLatest(ACTION.UPDATE_PROPERTY.SUCCESS, saga.updatePropertySuccess);
}
